import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, ExternalLink, Globe, MapPin, Phone } from 'lucide-react';
const CALENDLY_URL = 'https://calendly.com/bytewebstudio/15min';
export function ContactSection() {
  return <section id="contact" className="bg-dark-lighter py-24" data-id="element-40" data-mp="2kkyl28ugas06">
      <div className="mx-auto max-w-[1320px] px-4" data-id="element-41" data-mp="2pigvk3o49faa">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-2" data-id="element-42" data-mp="2pj062zbft1ea">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-43" data-mp="3d81faos3ggkm">
            <p className="mb-3 font-inter text-xs font-bold uppercase tracking-[0.2em] text-gold" data-id="element-44" data-mp="388ydrebboshe">
              Start a project
            </p>
            <h2 className="font-syne text-4xl font-bold text-white md:text-5xl" data-id="element-45" data-mp="1sqwjvv7l5pi8">
              A better digital experience{' '}
              <span className="text-gold" data-id="element-46" data-mp="1wrq7sol134b4">starts with a conversation.</span>
            </h2>
            <p className="mt-6 max-w-md font-inter text-lg leading-relaxed text-white/65" data-id="element-47" data-mp="7o91kc3rz2ti">
              Tell us where you want to go. We’ll bring the right questions,
              practical thinking and a clear path to get there.
            </p>

            <div className="mt-12 space-y-8" data-id="element-48" data-mp="ckzrdr5dtcs4">
              <div className="flex items-start gap-6" data-id="element-49" data-mp="cnc860zelh3l">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-white/10 bg-dark text-gold" data-id="element-50" data-mp="qk8ze3jfp0l0">
                  <Phone className="h-6 w-6" data-id="element-51" data-mp="ljtkv8nf1n1g" />
                </div>
                <div data-id="element-52" data-mp="109sinab26wge">
                  <h3 className="font-syne text-xl font-bold text-white" data-id="element-53" data-mp="10a0t6vjplpof">
                    Call the studio
                  </h3>
                  <a href="tel:+27712158291" className="mt-1 inline-block font-inter text-white/60 transition-colors hover:text-gold" data-id="element-54" data-mp="19bi8ibpalnc2">
                    071 215 8291
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-6" data-id="element-55" data-mp="1x6gfjnpv11t">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-white/10 bg-dark text-gold" data-id="element-56" data-mp="6yvsn2modkrh">
                  <Globe className="h-6 w-6" data-id="element-57" data-mp="axuqy4dwij9y" />
                </div>
                <div data-id="element-58" data-mp="fryzgs2tezd5">
                  <h3 className="font-syne text-xl font-bold text-white" data-id="element-59" data-mp="fs8rsmbc1im0">
                    Byteweb online
                  </h3>
                  <a href="https://byteweb.co.za" target="_blank" rel="noopener noreferrer" className="mt-1 inline-block font-inter text-white/60 transition-colors hover:text-gold" data-id="element-60" data-mp="po2c4rvamgec">
                    byteweb.co.za
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-6" data-id="element-61" data-mp="30gn2uzilbwnl">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-white/10 bg-dark text-gold" data-id="element-62" data-mp="30hepvly4gm29">
                  <MapPin className="h-6 w-6" data-id="element-63" data-mp="2o6dwk10ytfw1" />
                </div>
                <div data-id="element-64" data-mp="2o52se03ly64e">
                  <h3 className="font-syne text-xl font-bold text-white" data-id="element-65" data-mp="2o4klm9jbk9i8">
                    Based in Cape Town
                  </h3>
                  <p className="mt-1 font-inter text-white/60" data-id="element-66" data-mp="2f6igbhsjyup5">
                    South Africa, working with teams near and far.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col rounded-2xl border border-white/5 bg-dark p-6 md:p-8" data-id="element-67" data-mp="36xes0f2vmtau">
            <div className="mb-6 flex items-center gap-3" data-id="element-68" data-mp="1mgsb5y8wf356">
              <div className="flex h-12 w-12 items-center justify-center rounded-full border border-gold/20 bg-gold/10" data-id="element-69" data-mp="1mjej3yzpbknx">
                <Calendar className="h-6 w-6 text-gold" data-id="element-70" data-mp="3f46ievw7dvgf" />
              </div>
              <div data-id="element-71" data-mp="3f6avo4fzs6td">
                <h3 className="font-syne text-xl font-bold text-white" data-id="element-72" data-mp="31dbhc5ry4ine">
                  Book a consultation
                </h3>
                <p className="font-inter text-sm text-white/50" data-id="element-73" data-mp="35fojylbec0fy">
                  Choose a time that works for your team.
                </p>
              </div>
            </div>

            <div className="min-h-[500px] flex-1 overflow-hidden rounded-xl border border-white/10 bg-true-white" data-id="element-74" data-mp="1yg2i2kkz2lr">
              <iframe src={CALENDLY_URL} width="100%" height="100%" frameBorder="0" className="min-h-[500px]" title="Book a Byteweb consultation" data-id="element-75" data-mp="3k2hs96mi05yn" />
            </div>

            <div className="mt-4 text-center" data-id="element-76" data-mp="2do0bwazni02x">
              <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 font-inter text-sm font-medium text-gold transition-colors hover:text-white" data-id="element-77" data-mp="2dos89o12o1u9">
                Open booking in Calendly
                <ExternalLink size={14} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-78" data-mp="2f29zmki2c664" />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}